import { render, staticRenderFns } from "./reviewManagement.vue?vue&type=template&id=9f835ecc&scoped=true"
import script from "./reviewManagement.vue?vue&type=script&lang=js"
export * from "./reviewManagement.vue?vue&type=script&lang=js"
import style0 from "./reviewManagement.vue?vue&type=style&index=0&id=9f835ecc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f835ecc",
  null
  
)

export default component.exports